<template>
  <div class="the-header-menu-mobile">
    <z-button
      aria-label="menu"
      variant="tertiary"
      @click="isOpen = true"
    >
      <z-icon
        :icon="['far', 'bars']"
        size="large"
      />
    </z-button>

    <div :class="['the-header-menu-mobile__content', { 'the-header-menu-mobile__content--visible': isOpen }]">
      <div class="the-header-menu-mobile__content-header">
        <TheHeaderBrand />

        <z-button
          aria-label="menu"
          variant="tertiary"
          @click="isOpen = false"
        >
          <z-icon
            :icon="['far', 'times']"
            size="large"
          />
        </z-button>
      </div>

      <z-list-box
        class="the-header-menu-mobile__menu"
        accessibility-text="Menu de navegação principal"
      >
        <z-list-box-option
          v-for="item in items"
          :key="item.text"
        >
          <z-list-box-option-label
            :title="item.text"
            tag="a"
            :href="item.href"
          />
        </z-list-box-option>
      </z-list-box>

      <z-divider />

      <TheHeaderHelpCenterFooter class="the-header-menu-mobile__help-center" />
    </div>
  </div>
</template>

<script>
import TheHeaderHelpCenterFooter from './the-header-help-popover-footer'
import TheHeaderBrand from './the-header-brand'

import { enableBodyScroll, disableBodyScroll } from '~/assets/js/utils/scroll'

export default {
  name: 'TheHeaderMenuMobile',
  components: {
    TheHeaderHelpCenterFooter,
    TheHeaderBrand,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      isOpen: false,
    }
  },
  watch: {
    async isOpen (isOpen) {
      await this.$nextTick()

      if (isOpen) {
        disableBodyScroll()
      } else {
        enableBodyScroll()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.the-header-menu-mobile__content {
  background-color: var(--color-white);
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  transform: translateX(100%);
  transition: transform var(--transition-duration) var(--transition-function);
  z-index: var(--z-index-overlay);
}

.the-header-menu-mobile__content--visible {
  transform: translateX(0);
}

.the-header-menu-mobile__menu {
  flex: 1;
  padding-top: var(--unit-0400);
}

.the-header-menu-mobile__content-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: var(--unit-0400);
}

.the-header-menu-mobile__help-center {
  padding: var(--unit-0400);
}
</style>
